import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ArrowLeft, Home } from 'lucide-react';
import { Button } from './ui/button';

interface PermissionDeniedPageProps {
  resource?: string;
  action?: string;
  requiredPermission?: string;
}

const RESOURCE_NAMES: Record<string, string> = {
  deals: 'Trattative',
  clients: 'Clienti',
  projects: 'Progetti',
  calendar: 'Calendario',
  documents: 'Documenti',
  reports: 'Report',
  users: 'Utenti',
  roles: 'Ruoli',
  settings: 'Impostazioni',
  inventory: 'Magazzino',
  services: 'Servizi',
  commissions: 'Commissioni',
  whatsapp: 'WhatsApp',
  analytics: 'Analytics',
  invoices: 'Fatture',
  tasks: 'Tasks',
  leads: 'Lead',
  partners: 'Partner',
  wiki: 'Wiki',
  newsletter: 'Newsletter',
  email_campaigns: 'Campagne email',
  tickets: 'Ticket',
  team_chat: 'Chat di team',
  meetings: 'Meeting',
  forms: 'Form',
  surveys: 'Survey',
  marketing: 'Marketing',
  service_costs: 'Costi servizi',
  client_expenses: 'Costi servizi',
  contracts: 'Contratti',
  automations: 'Automazioni',
  superadmin: 'Pannello Super Admin',
  partner_admin: 'Pannello Partner Admin',
};

const ACTION_NAMES: Record<string, string> = {
  view: 'visualizzare',
  create: 'creare',
  update: 'modificare',
  delete: 'eliminare',
  manage: 'gestire',
  assign: 'assegnare',
  import: 'importare',
  export: 'esportare',
  generate: 'generare',
  archive: 'archiviare',
};

export function PermissionDeniedPage({
  resource = 'questa sezione',
  action = 'view',
  requiredPermission,
}: PermissionDeniedPageProps) {
  const navigate = useNavigate();

  const resourceLabel = RESOURCE_NAMES[resource] || resource;
  const actionLabel = ACTION_NAMES[action] || action;

  return (
    <div className="min-h-screen bg-[#FBFBFA] flex flex-col items-center justify-center px-4 py-12">
      <img
        src="/logo_colorato.png"
        alt="Flusia"
        className="h-8 w-auto mb-12 opacity-80"
      />

      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl p-10 text-center">
        <div className="mx-auto mb-6 h-16 w-16 rounded-full bg-gray-100 flex items-center justify-center">
          <Lock className="h-8 w-8 text-gray-500" strokeWidth={1.5} />
        </div>

        <h1 className="text-3xl font-semibold text-gray-900 mb-3 tracking-tight">
          Non hai accesso a questa sezione
        </h1>

        <p className="text-base text-gray-500 leading-relaxed mb-8">
          Il tuo ruolo attuale non include il permesso per {actionLabel}{' '}
          <span className="font-medium text-gray-700">{resourceLabel}</span>. Se ti
          serve accedere, contatta un amministratore della tua organizzazione.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6">
          <Button
            variant="default"
            onClick={() => navigate('/dashboard')}
            className="gap-2"
          >
            <Home className="h-4 w-4" />
            Vai alla dashboard
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Indietro
          </Button>
        </div>

        {requiredPermission && (
          <div className="pt-6 border-t border-gray-100">
            <p className="text-xs text-gray-400 font-mono">
              Permesso richiesto: {requiredPermission}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
